import { render, staticRenderFns } from "./cases.vue?vue&type=template&id=73075bc9&scoped=true&"
import script from "./cases.vue?vue&type=script&lang=js&"
export * from "./cases.vue?vue&type=script&lang=js&"
import style0 from "./cases.vue?vue&type=style&index=0&id=73075bc9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73075bc9",
  null
  
)

export default component.exports